"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_VALIDATION = void 0;
// ES5-compatible pattern that allows international names by blocking problematic characters
// Blocks: special characters (@, #, $, %, etc.)
// Allows: all letters (including Unicode like José, Müller, 张伟, محمد), numbers, spaces, apostrophes, hyphens, periods
var NAME_PATTERN = /^[^@#$%^&*()_+=[\]{}|\\<>?/~`!;:"]+$/;
var EMAIL_VALIDATION = {
    pattern: {
        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        message: 'Please enter a valid email address.',
    },
};
exports.FIELD_VALIDATION = {
    applicant_title: {
        maxLength: {
            value: 50,
            message: 'Title is too long (max 50 characters)',
        },
    },
    applicant_name_first: {
        minLength: {
            value: 1,
            message: 'First name must be at least 1 character',
        },
        maxLength: {
            value: 50,
            message: 'First name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'First name must not contain special characters',
        },
    },
    applicant_name_middle: {
        maxLength: {
            value: 50,
            message: 'Middle name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'Middle name must not contain special characters',
        },
    },
    applicant_name_last: {
        minLength: {
            value: 1,
            message: 'Last name must be at least 1 character',
        },
        maxLength: {
            value: 50,
            message: 'Last name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'Last name must not contain special characters',
        },
    },
    applicant_former_name_last: {
        maxLength: {
            value: 50,
            message: 'Former Last Name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'Former Last Name must not contain special characters',
        },
    },
    alternate_first_name: {
        maxLength: {
            value: 50,
            message: 'Alternate First Name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'Alternate First Name must not contain special characters',
        },
    },
    alternate_middle_name: {
        maxLength: {
            value: 50,
            message: 'Alternate Middle Name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'Alternate Middle Name must not contain special characters',
        },
    },
    alternate_last_name: {
        maxLength: {
            value: 50,
            message: 'Alternate Last Name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'Alternate Last Name must not contain special characters',
        },
    },
    applicant_name_preferred: {
        maxLength: {
            value: 50,
            message: 'Preferred Name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'Preferred Name must not contain special characters',
        },
    },
    // CreateAccountForm field names
    firstName: {
        minLength: {
            value: 1,
            message: 'First Name must be at least 1 character',
        },
        maxLength: {
            value: 50,
            message: 'First Name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'First Name must not contain special characters',
        },
    },
    lastName: {
        minLength: {
            value: 1,
            message: 'Last Name must be at least 1 character',
        },
        maxLength: {
            value: 50,
            message: 'Last Name is too long (max 50 characters)',
        },
        pattern: {
            value: NAME_PATTERN,
            message: 'Last Name must not contain special characters',
        },
    },
    applicant_primary_number: {},
    applicant_birth_date: {},
    applicant_marital_status: {},
    applicant_employment_status: {},
    applicant_job_title: {},
    applicant_current_annual_income: {
        pattern: {
            value: /^\d+(\.\d{1,2})?$/,
            message: 'Enter a valid income amount.',
        },
    },
    applicant_employer_postal_code: {
        pattern: {
            value: /^(\d{5}(-\d{4})?)$/,
            message: 'Invalid ZIP code format.',
        },
    },
    applicant_email_address: __assign({}, EMAIL_VALIDATION),
    email: __assign({}, EMAIL_VALIDATION),
    coapplicant_email: __assign({}, EMAIL_VALIDATION),
    applicant_social_security_number: {
        pattern: {
            value: /(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}/,
            message: 'Invalid Social Security Number (SSN).',
        },
    },
    // Pets
    applicant_pet_type: {},
    applicant_pet_assistance_animal: {},
    applicant_pet_breed: {},
    applicant_pet_weight: {},
    applicant_pet_spyed: {},
    applicant_pet_house_broken: {},
    applicant_pet_name: {},
    applicant_pet_color: {},
    applicant_pet_age: {},
    applicant_pet_gender: {},
    applicant_pet_spyed_date: {},
    applicant_pet_rabies_shot_date: {},
    applicant_pet_license_number: {},
    applicant_pet_license_city: {},
    applicant_pet_owner_name: {},
    bob: {},
};
